import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dashboard } from '../interfaces/Dashboard';
import { iconesMap } from '../lib/icones';
import api from '../services/api';
import Category from './Category';
import Home from './Home';
import { mapDomain } from '../lib/mapDomain';
import links from '../links.json';

interface CategoriesData {
  [key: string]: Dashboard[];
}


interface NavItemProps {
  item: string;
  selected: string;
  children: JSX.Element;
  onClick: (item: string) => void;
}
function NavItem({ selected, item, children, onClick }: NavItemProps) {
  return (
    <div onClick={() => onClick(item)} className={`menu-item ${selected === item ? 'active' : ''}`}>
      {children}
    </div>
  )
}

interface TabContentProps {
  item: string;
  selected: string;
  children: JSX.Element;
}
function TabContent({ selected, item, children }: TabContentProps) {
  return (
    <div hidden={selected !== item} >
      {children}
    </div>
  )
}

export function Tabs() {
  const [categoriesData, setCategoriesData] = useState<CategoriesData>({});
  const [mostViewedDashboards, setMostViewedDashboards] = useState<Dashboard[]>([]);
  const [selected, setSelected] = useState("Home");

  useEffect(() => {
    // api.get('/dashboards').then(({ data }: { data: Dashboard[] }) => {
    //   const categories: CategoriesData = {};
    //   setMostViewedDashboards(data.sort((a, b) => b.accessCounter - a.accessCounter));
    //   data.forEach((dashboard: Dashboard) => {
    //     dashboard.domain = mapDomain(dashboard.domain);
    //     if (!categories[dashboard.domain]) {
    //       categories[dashboard.domain] = [];
    //     }
    //     categories[dashboard.domain].push(dashboard);
    //   });
    //   setCategoriesData(categories);
    // })
    const categories: CategoriesData = {};
      setMostViewedDashboards(links.sort((a, b) => b.accessCounter - a.accessCounter));
      links.forEach((dashboard: Dashboard) => {
        dashboard.domain = mapDomain(dashboard.domain);
        if (!categories[dashboard.domain]) {
          categories[dashboard.domain] = [];
        }
        categories[dashboard.domain].push(dashboard);
      });
      setCategoriesData(categories);
  }, [])

  return (
    <div className="corpo">
      <div className="menu">
        <NavItem selected={selected} item={"Home"} onClick={setSelected}>
          <>
            <FontAwesomeIcon icon={iconesMap["Home"]} className="fa-xl" />
            <span>Início</span>
          </>
        </NavItem>
        {Object.keys(categoriesData).map((category) => (
          <NavItem selected={selected} item={category} onClick={setSelected} key={category}>
            <>
              <FontAwesomeIcon icon={iconesMap[category]} className="fa-xl" />
              <span>{category}</span>
            </>
          </NavItem>          
        ))}
      </div>
      <div className=''>
        <TabContent selected={selected} item={"Home"}>
          <Home dashboards={mostViewedDashboards} categoriesDomain={categoriesData} />
        </TabContent>
        {Object.keys(categoriesData).map((category) => (
          <TabContent selected={selected} item={category} key={category}>
            <Category title={category} dashboards={categoriesData[category]} />
          </TabContent>
        ))}
      </div>
    </div>
  );
}

